/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export class OsdTypes {
    static DEFAULT = 'full-screen';

    static FULL_INFO_BANNER = 'full-info-banner';

    static STANDARD_INFO_BANNER = 'standard-info-banner';

    static FULL_INFO_BANNER_ADULT = 'full-info-banner-adult';

    static TRICKPLAY_MENU = 'trickplay-menu';

    static MINIMIZED_FULL_INFO_BANNER = 'minimized-full-info-banner';
}
